import {
  GET_FUSIONS_FAILURE,
  GET_FUSIONS_REQUEST,
  GET_FUSIONS_SUCCESS,
} from '../../constants/action-types';

const getInitialState = () => {
  return {
    isLoading: false,
    data: {},
    error: false,
  };
};

const initialState = getInitialState();

const fusions = (state = initialState, action) => {
  const types = {
    [GET_FUSIONS_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_FUSIONS_SUCCESS]: () => ({
      ...state,
      isLoading: false,
      error: false,
      data: action.response,
    }),
    [GET_FUSIONS_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default fusions;
